<template>
  <div class="container">
    <div class="iframe-menu">
      <iframe id="cinema" ref="cinema" :src="cinema"></iframe>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref, computed, watch } from 'vue'
  import { useStore } from 'vuex'
  import saveCinemaTurn from '@/plugins/saveQuendaTurn'
  import { onUnmounted } from 'vue'
  import mainMessageMethodListener from '@/plugins/listenerMessageMethod'

  const store = useStore()
  const FingerprintJS = require('@fingerprintjs/fingerprintjs')
  const fpPromise = FingerprintJS.load()

  let fbToken = computed(() => store.state.session.fbToken)
  let storeId = computed(() => store.getters['getStoreId'])
  const cinema = process.env.VUE_APP_CINEMA

  const manageMessage = async (event) => {
    const oData = event.data
    if (oData.idCita) {
      // Get the visitor identifier when you need it.
      const fp = await fpPromise
      const result = await fp.get()

      saveCinemaTurn(
        oData.idCita,
        fbToken.value,
        result.visitorId,
        storeId.value
      )
    }
  }

  onMounted(() => {
    window.addEventListener('message', function (event) {
      manageMessage(event)
      mainMessageMethodListener(event)
    })
  })

  onUnmounted(() => {
    window.removeEventListener('message', manageMessage)
    
    window.addEventListener('message', function (event) {
      mainMessageMethodListener(event)
    })  
  })
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';
  .iframe-menu {
    @include d-flex(row, space-between, initial);
    height: 100%;
    #cinema {
      width: 100%;
      border: 0;
    }
  }
</style>
